import {
  CognitoUserAttribute,
  CognitoUserPool,
} from "amazon-cognito-identity-js";
import React, { useEffect, useState } from "react";
import {
  Avatar,
  Button,
  CssBaseline,
  TextField,
  Link,
  Select,
  MenuItem,
  Grid,
  Box,
  Container,
  Typography,
  FormControl,
  InputLabel,
  Alert,
} from "@mui/material";
import { LockOutlined } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { Country, City } from "country-state-city";
import { MuiTelInput } from 'mui-tel-input'

import { useSearchParams } from "react-router-dom";
import axios from "axios";
import config from "../../config";
import useStore from "../../store";

export default function Signup() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const countries = Country.getAllCountries([]);

  const [username, setUserName] = useState("");
  const [role, setRole] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [givenName, setGivenName] = useState("");
  const [familyName, setFamilyName] = useState("");
  const [gender, setGender] = useState("");
  const [BirthDate, setBirthDate] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [country, setCountry] = useState("EG");
  const [city, setCity] = useState("");
  const [cities, setCities] = useState([]);
  const [poolParams, setPoolParams] = useState({});
  const [loading, setLoading] = useState(false);

  const { error, setError, tenantId, setTenantId } = useStore((state) => state);

  useEffect(() => {
    setCities(City.getCitiesOfCountry(country));
  }, [country]);

  useEffect(() => {
    setTenantId(
      searchParams.get("tenantId") ? searchParams.get("tenantId") : null
    );
    if (tenantId) {
      setError("");
      axios
        .get(`${config.tenantsURL}/tenant_id/${tenantId}`)
        .then((response) => {
          const tenant = response.data.tenant;
          const poolId = tenant?.issuer.split("/")[3];
          const clientId = tenant?.app_client_id;
          setPoolParams({ UserPoolId: poolId, ClientId: clientId });
        });
    } else {
      setLoading(false);
      setError("There is no tenant provided");
    }
  }, [searchParams, setError, setPoolParams, setTenantId, tenantId]);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (
      username === "" ||
      role === "" ||
      password === "" ||
      email === "" ||
      givenName === "" ||
      familyName === "" ||
      gender === "" ||
      BirthDate === "" ||
      phoneNumber === "" ||
      country === "" ||
      city === ""
    ) {
      setError("* Fields are required");
      return;
    }
    if (poolParams.UserPoolId && poolParams.ClientId) {
      const attributeList = [
        new CognitoUserAttribute({ Name: "email", Value: email }),
        new CognitoUserAttribute({ Name: "given_name", Value: givenName }),
        new CognitoUserAttribute({ Name: "family_name", Value: familyName }),
        new CognitoUserAttribute({ Name: "gender", Value: gender }),
        new CognitoUserAttribute({ Name: "birthdate", Value: BirthDate }),
        new CognitoUserAttribute({
          Name: "phone_number",
          Value: phoneNumber,
        }),
        new CognitoUserAttribute({ Name: "custom:country", Value: country }),
        new CognitoUserAttribute({ Name: "custom:city", Value: city }),
        new CognitoUserAttribute({ Name: "custom:role", Value: role }),
      ];
      const Pool = new CognitoUserPool(poolParams);

      Pool.signUp(username, password, attributeList, null, (err, data) => {
        if (err) {
          setError(err.message);
          console.error(err);
        } else {
          setError("");
          navigate(`/verify-email?tenantId=${tenantId}`);
        }
      });
    } else {
      setError(`Tenant ${tenantId} not found`);
    }
  };

  return (
    <>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
            <LockOutlined />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign up
          </Typography>{" "}
          {error && (
            <Alert sx={{ width: "100%" }} severity="error">
              {error}
            </Alert>
          )}
          <Box
            component="form"
            noValidate
            onSubmit={handleSubmit}
            sx={{ mt: 3 }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12} sm={8}>
                <TextField
                  required
                  fullWidth
                  name="username"
                  label="Username"
                  id="username"
                  autoFocus
                  value={username}
                  onChange={(event) => setUserName(event.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <FormControl fullWidth required>
                  <InputLabel>Role</InputLabel>
                  <Select
                    label="Role"
                    name="role"
                    value={role}
                    onChange={(event) => setRole(event.target.value)}
                  >
                    <MenuItem value="teacher">Teacher</MenuItem>
                    <MenuItem value="student">Student</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  id="email"
                  label="Email Address"
                  name="email"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  name="password"
                  label="Password"
                  type="password"
                  id="password"
                  value={password}
                  onChange={(event) => setPassword(event.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  name="givenName"
                  required
                  fullWidth
                  id="givenName"
                  label="First Name"
                  value={givenName}
                  onChange={(event) => setGivenName(event.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  fullWidth
                  id="familyName"
                  label="Last Name"
                  name="familyName"
                  value={familyName}
                  onChange={(event) => setFamilyName(event.target.value)}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormControl fullWidth required>
                  <InputLabel>Gender</InputLabel>
                  <Select
                    label="Gender"
                    name="gender"
                    value={gender}
                    onChange={(event) => setGender(event.target.value)}
                  >
                    <MenuItem value="male">Male</MenuItem>
                    <MenuItem value="female">Female</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  fullWidth
                  id="date"
                  label="BirthDate"
                  type="date"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(event) => setBirthDate(event.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth required>
                  <InputLabel>Country</InputLabel>
                  <Select
                    label="Country"
                    name="country"
                    value={country}
                    onChange={(event) => setCountry(event.target.value)}
                  >
                    {countries.map((c) => {
                      return (
                        <MenuItem key={c.isoCode} value={c.isoCode}>
                          {c.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth required>
                  <InputLabel>City</InputLabel>
                  <Select
                    label="City"
                    name="city"
                    value={city}
                    onChange={(event) => setCity(event.target.value)}
                  >
                    {cities.map((c, i) => {
                      return (
                        <MenuItem key={i} value={c.name}>
                          {c.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <MuiTelInput
                  required
                  fullWidth
                  name="phoneNumber"
                  id="phoneNumber"
                  label="Phone Number"
                  value={phoneNumber}
                  defaultCountry={country.toLowerCase() || "eg"}
                  onChange={(value) => setPhoneNumber(value)}
                />
              </Grid>
            </Grid>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              {loading && (
                <span className="spinner-border spinner-border-sm"></span>
              )}
              Sign Up
            </Button>
            <Grid container justifyContent="flex-end">
              <Grid item>
                <Link href={`/?tenantId=${tenantId}`} variant="body2">
                  Already have an account? Sign in
                </Link>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Container>
    </>
  );
}
